import React, { useEffect, useState } from 'react';
import { Button, Empty, Flex, Modal, Spin } from 'antd';
import Cockpit from './components/Cockpit';
import IssueApi from '@/fetch/bussiness/issue';
import { useSelector } from 'react-redux';
import './index.scss';
import { RootState } from '@/index';
import { HttpStatusCode } from '@/fetch/core/constant';
import { showMsg } from '@/utils/util';
import { CockpitType, IssueStatus, IssueType } from '@/utils/constant';
import { isEmpty, isNullObject } from '@/utils';
interface Props {
  open: boolean;
  setOpen: AnyFunc;
  type: 'TRANSFER' | 'ALLOCATE';
  vehicleName?: string;
  issueNumber?: string;
  refreshFunc?: AnyFunc;
}
const fetchApi = new IssueApi();
const TransferIssueModal = (props: Props) => {
  const { open, setOpen, vehicleName, type, issueNumber, refreshFunc } = props;
  const [cockpitList, setCockpitList] = useState<any[]>([]);
  const [selectedCockpit, setSelectedCockpit] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const { cockpitTeamNumber } = useSelector(
    (state: RootState) => state.cockpitInfo,
  );
  const { issueList } = useSelector((state: RootState) => state.workOrder);
  const currentIssue =
    (issueList &&
      issueList?.find(
        (issue: any) =>
          issue.vehicleName === vehicleName &&
          issue.issueType === IssueType.OPS,
      )) ??
    {};

  useEffect(() => {
    if (open) {
      getUsableCockpitList();
    }
  }, [open]);
  const getUsableCockpitList = async () => {
    try {
      const res = await fetchApi.getTransferCockpitList(
        cockpitTeamNumber,
        vehicleName!,
      );
      if (res.code === HttpStatusCode.Success) {
        setCockpitList(res?.data);
        setLoading(false);
      } else {
        showMsg({
          msg: res.message,
          type: 'error',
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  const confirmTransfer = async (acceptNewIssue: boolean) => {
    try {
      const res = await fetchApi.transferIssue({
        issueNumber: currentIssue.issueNumber,
        cockpitNumber: selectedCockpit?.cockpitNumber,
        acceptNewIssue: acceptNewIssue,
      });
      if (res.code === HttpStatusCode.Success) {
        showMsg({
          msg: '转单成功',
          type: 'success',
        });
        setOpen(false);
      } else {
        showMsg({
          msg: res.message,
          type: 'error',
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
  const confirmAllocate = async () => {
    try {
      const res =
        issueNumber &&
        (await fetchApi.allocateIssue({
          issueNumber: issueNumber,
          cockpitNumber: selectedCockpit?.cockpitNumber,
        }));
      if (res.code === HttpStatusCode.Success) {
        showMsg({
          msg: '派单成功',
          type: 'success',
        });
        setOpen(false);
      } else {
        showMsg({
          msg: res.message,
          type: 'error',
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      refreshFunc && refreshFunc();
    }
  };
  return (
    <>
      <Modal
        width={1100}
        title={type === 'TRANSFER' ? '选择转单座席' : '选择派单座席'}
        centered
        open={open}
        destroyOnClose
        onCancel={() => {
          setOpen(false);
          setSelectedCockpit(null);
          setCockpitList([]);
        }}
        footer={
          <>
            <div className='footer'>
              {!isNullObject(selectedCockpit) ? (
                <div className='select-cockpit-info'>
                  <span className='label'>
                    已选：
                    <span className='info'>
                      {selectedCockpit.cockpitType === CockpitType.MONITOR_SEAT
                        ? `监控端${selectedCockpit.cockpitNumber}座席（${selectedCockpit.cockpitUserName}）`
                        : `驾驶端${selectedCockpit.cockpitNumber}座席（${selectedCockpit.cockpitUserName}）`}
                    </span>
                  </span>
                </div>
              ) : (
                <></>
              )}
              <div className='operate'>
                <Button
                  onClick={() => {
                    setOpen(false);
                    setSelectedCockpit(null);
                    setCockpitList([]);
                  }}
                  style={{
                    marginRight: '12px',
                  }}
                >
                  取消
                </Button>
                <Button
                  disabled={isNullObject(selectedCockpit)}
                  type={'primary'}
                  onClick={() => {
                    type === 'TRANSFER'
                      ? confirmTransfer(true)
                      : confirmAllocate();
                  }}
                >
                  {type === 'TRANSFER' ? '确认转单' : '确认派单'}
                </Button>
                {type === 'TRANSFER' &&
                  issueList &&
                  issueList.length > 1 &&
                  issueList.find(
                    (issue: any) => issue.issueStatus === IssueStatus.ON_HOLD,
                  ) &&
                  currentIssue?.issueStatus != IssueStatus.ON_HOLD && (
                    <Button
                      style={{
                        marginLeft: '12px',
                      }}
                      disabled={isNullObject(selectedCockpit)}
                      type={'primary'}
                      onClick={() => {
                        confirmTransfer(false);
                      }}
                    >
                      确定转单并受理挂起工单
                    </Button>
                  )}
              </div>
            </div>
          </>
        }
      >
        <Spin spinning={loading} tip='Loading...'>
          <div className='wrapper'>
            <div className='cockpit-box'>
              <div className='title-wrapper'>
                <div className='title-text'>监控座席</div>
              </div>

              {!isEmpty(cockpitList) ? (
                <Flex
                  justify='flexStart'
                  align='center'
                  gap='middle'
                  wrap={'wrap'}
                  style={{ padding: '5px 20px' }}
                >
                  {cockpitList.map((cockpit: any) => {
                    return (
                      <>
                        {cockpit?.cockpitType === CockpitType.MONITOR_SEAT && (
                          <Cockpit
                            key={cockpit?.cockpitNumber}
                            selected={
                              selectedCockpit?.cockpitNumber ===
                              cockpit.cockpitNumber
                            }
                            setSelectedCockpit={setSelectedCockpit}
                            cockpitNumber={cockpit?.cockpitNumber}
                            cockpitUserName={cockpit?.cockpitUserName}
                            cockpitType={cockpit.cockpitType}
                            issueTotal={cockpit.issueTotal}
                          />
                        )}
                      </>
                    );
                  })}
                </Flex>
              ) : (
                <Flex
                  justify='center'
                  align='center'
                  gap='middle'
                  wrap={'wrap'}
                  style={{ padding: '5px 20px', height: '100%' }}
                >
                  <Empty
                    image={
                      <img
                        src={require('../../assets/img/views/empty_cockpit_list_icon.png')}
                      ></img>
                    }
                    description={
                      <p style={{ color: '#fff' }}>
                        暂无可{type === 'TRANSFER' ? '转单' : '派单'}座席
                      </p>
                    }
                  />
                </Flex>
              )}
            </div>
            <div className='cockpit-box'>
              <div className='title-wrapper'>
                <div className='title-text'>驾舱座席</div>
              </div>
              {!isEmpty(cockpitList) ? (
                <Flex
                  justify='flexStart'
                  align='center'
                  gap='middle'
                  wrap='wrap'
                  style={{ padding: '5px 20px' }}
                >
                  {cockpitList.map((cockpit: any) => {
                    return (
                      <>
                        {cockpit?.cockpitType === CockpitType.COCKPIT_SEAT && (
                          <Cockpit
                            key={cockpit?.cockpitNumber}
                            selected={
                              selectedCockpit?.cockpitNumber ===
                              cockpit.cockpitNumber
                            }
                            setSelectedCockpit={setSelectedCockpit}
                            cockpitNumber={cockpit?.cockpitNumber}
                            cockpitUserName={cockpit?.cockpitUserName}
                            cockpitType={cockpit.cockpitType}
                            issueTotal={cockpit.issueTotal}
                          />
                        )}
                      </>
                    );
                  })}
                </Flex>
              ) : (
                <Flex
                  justify='center'
                  align='center'
                  gap='middle'
                  wrap='wrap'
                  style={{ padding: '5px 20px', height: '100%' }}
                >
                  <Empty
                    image={
                      <img
                        src={require('../../assets/img/views/empty_cockpit_list_icon.png')}
                      ></img>
                    }
                    description={
                      <p style={{ color: '#fff' }}>
                        暂无可{type === 'TRANSFER' ? '转单' : '派单'}座席
                      </p>
                    }
                  />
                </Flex>
              )}
            </div>
          </div>
        </Spin>
      </Modal>
    </>
  );
};
export default React.memo(TransferIssueModal);
